module.exports = __webpack_public_path__ + "static/img/left.8da1538.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/offcn-teacher-launch/img/left.png
// module id = njve
// module chunks = 1